import axios from "axios";

export const enviarMensaje = ({entidad}) => {


    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
       // url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/b7744546-645c-4dd1-9f36-05efa74f958b', //test
          url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/b7744546-645c-4dd1-9f36-05efa74f958b',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}